import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import label from "../../labels/accessRightsManagement_en.json";
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  saveDepartmentData,
  saveNewUserData,
} from "../../actions/accessRightsManagementActions";
const DeleteDepartment = (props) => {
  const { register, handleSubmit, formState, watch } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();
  let { departmentList } = useSelector(
    (state) => state?.accessRightsManagementReducer,
    shallowEqual
  );

  const onSubmit = () => {
    const MappingData = departmentList.map((item, index) => item);
    const filterData = MappingData.filter(
      (ele) => ele.id === props.setDeleteData.id
    );

    let data = {
      id: filterData[0].id,
      name: filterData[0].name,
      description: filterData[0].description,
      isActive: filterData[0].isActive,
      isDeleted: true,
    };
    dispatch(saveDepartmentData(data));

    props.setShowDeleteModal(false);
  };
  return (
    <Modal
      size="xs"
      show={props.showDeleteModal}
      onHide={() => {
        props.setShowDeleteModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xs"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-xs">
          Are you sure you want to delete?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="row"> */}
        <div className="row custom-button text-align-right">
          <button
            className="btn btn-secondary ml-auto mr-2"
            type="button"
            onClick={() => {
              props.setShowDeleteModal(false);
            }}
          >
            {label.No}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit((e) => {
              onSubmit(e);
            })}
          >
            {label.Yes}
          </button>
        </div>
        {/* </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default DeleteDepartment;
